import { reactive } from "vue"
import { createResource, frappeRequest } from "frappe-ui"

// Order matters — first matching role wins. Matches the real Role names
// seeded on construction.localhost (see seed_new_construction_company.py).
const ROLE_HOME = [
	["System Manager", "/admin"],
	["Administrator", "/admin"],
	["Project Director", "/director"],
	["Construction Project Manager", "/pm"],
	["Planning Engineer", "/planning"],
	["Quantity Surveyor", "/qs"],
	["Site Engineer", "/site"],
	["Procurement Officer", "/procurement"],
	["Store Keeper", "/store"],
	["Equipment Manager", "/equipment"],
	["QA/QC Engineer", "/qaqc"],
	["HSE Officer", "/hse"],
]

export const session = reactive({
	user: null,
	fullName: null,
	roles: [],
	company: null,
	isLoggedIn: false,
	home: "/director",
})

function applyContext(ctx) {
	session.user = ctx.user
	session.fullName = ctx.full_name
	session.roles = ctx.roles || []
	session.company = ctx.company || null
	session.isLoggedIn = !!ctx.user && ctx.user !== "Guest"

	const match = ROLE_HOME.find(([role]) => session.roles.includes(role))
	session.home = match ? match[1] : "/director"
}

export const contextResource = createResource({
	url: "construction_erp.api.session.context",
	onSuccess: applyContext,
})

export async function fetchContext() {
	try {
		const ctx = await contextResource.fetch()
		return ctx
	} catch {
		session.isLoggedIn = false
		return null
	}
}

export async function login(email, password) {
	await frappeRequest({
		url: "/api/method/login",
		method: "POST",
		params: { usr: email, pwd: password },
	})
}

export async function logout() {
	await frappeRequest({ url: "/api/method/logout", method: "POST" })
	session.user = null
	session.isLoggedIn = false
	window.location.href = "/constructionos"
}
